module.exports = __webpack_public_path__ + "img/task-recharge-banner.d189fb73.svg";